import { create } from "zustand";

export const LLMTrackerStore = create((set) => ({
  ISPROJECT: false,
  SHOWLOADER: false,
  USER_LLM_PROJECT: [],
  SELECTED_PROJECT: null,
  LLM_PROJECT: null,
  CURRLOCATION: {
    code: "All Locations",
    name: "All Locations",
  },
  KEYWORD_LOC_DATA: "All Locations",
  KEYWORD_LATEST_DATA: [],
  KEYWORD_OLD_DATA: [],
  KEYWORD_ALL_LOC_DATA: [],
  OLD_DATA_DATE: { title: "days", day: 30, meta_des: "30", refresh: false },
  SHOW_COMPETITORS: false,
  LLM_RANK_GROUP: [],
}));
